import { facebookReviewUrl, googleReviewUrl } from "@servicepro/utils";
import type { JobsiteBusinessContext } from "../../types/runtime-config";

interface LeaveReviewLink {
  href: string;
  key: "facebook" | "google";
  label: string;
}

/** Every place this business can be reviewed, Google first. */
const leaveReviewLinksFor = (
  business: Pick<JobsiteBusinessContext, "facebookUrl" | "placeId"> | undefined,
): LeaveReviewLink[] => {
  const links: LeaveReviewLink[] = [];
  const placeId = business?.placeId?.trim() ?? "";
  if (placeId !== "") {
    links.push({ href: googleReviewUrl(placeId), key: "google", label: "Leave a review on Google" });
  }
  const facebookUrl = facebookReviewUrl(business?.facebookUrl ?? "");
  if (facebookUrl !== null) {
    links.push({ href: facebookUrl, key: "facebook", label: "Leave a review on Facebook" });
  }
  return links;
};

export type { LeaveReviewLink };
export { leaveReviewLinksFor };
